const Section9 = new function() {
    this.init = () => {
        if (!document.querySelector('.sn-section--9')) return;

        const sec9s = document.querySelectorAll('.sn-section--9');
        const isOpen = "opened";
        const isClosing = "is-closing";
        
        sec9s.forEach(sec9 => {
            const sec9Cards = sec9.querySelectorAll('.slider-item');

            sec9Cards.forEach(item => {
                const sec9CardsTop = item.querySelector('.sn-box__top');
                const sec9CardsBtn = item.querySelector('.sn-box__top > .sn-arrow-down-circle');

                if (!sec9CardsBtn) return;

                sec9CardsBtn.addEventListener('mouseenter', () => {
                    sec9CardsTop.classList.add(isOpen);
                });

                sec9CardsTop.addEventListener('mouseleave', () => {
                    sec9CardsTop.classList.add(isClosing);
                    sec9CardsTop.classList.remove(isOpen);

                    setTimeout(() => {
                        sec9CardsTop.classList.remove(isClosing);
                    }, 300);
                });

                // Touchstart -> toggle class
                sec9CardsBtn.addEventListener('touchstart', (e) => {
                    e.stopPropagation(); // Stop event bubbling
                    sec9CardsTop.classList.toggle(isOpen);
                });
            });
        });
    }
};

export default Section9;